import React , {Component } from 'react';
import Services from '../Sections/Services';
import Features from '../Sections/Features';
import Counter from '../Sections/Counter';
import Pricing from '../Sections/Pricing';
import Client from '../Sections/Client';
import Faq from '../Sections/Faq';
import Contact from '../Sections/Contact';
import { Link } from 'react-router-dom';
import AUX from '../../../hoc/Aux_';
import { connect } from 'react-redux';
import * as actionTypes from '../../../store/action';
import Modal from "react-responsive-modal";
import {fetchCms} from '../../../api/cms';
import {pushSearchText} from '../../../actions/general';
import Garuda from '../../../assets/Garuda.png';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import DirectionsIcon from '@material-ui/icons/Directions';
import { withRouter, Redirect } from "react-router";
import ReactTooltip from 'react-tooltip';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

class HomeOne extends Component{

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchText: '',
      cmsData:[],
      tipePencarian: 'big',
      tool: false
    }
  }

  componentWillMount() {
    fetchCms("header")
    .then(response => {
        if (response != null) {
          this.setState({cmsData:response.data});
        }
      })
      .catch(error => {
      });

  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  handleSearchText = (e)=> {
    console.log();
    this.setState({searchText: e.target.value})
  }

  onKeyPressed = (e) => {
     if(e.keyCode == 13){
       this.props.pushSearchText(this.state.searchText);
       this.props.history.push(`pencarian${this.state.tipePencarian}`);
     }

  }

  renderHeader = (e) =>{ 
    return (
      <span>
        <h1 className="mt-5 pt-1 home-title">{e.title}</h1>
        <p className="home-subtitle mx-auto pt-1">
          {e.description}
        </p>
      </span>

    )

  }

    render(){
        const { open } = this.state;

        var mystyle = {
            opacity : "0.8"
        }
        var modal_style = {
            backgroundColor: "black"
        }
        return(
            <AUX>

            <Modal open={open} style={modal_style}  onClose={this.onCloseModal} center>
              <video  width={550} height={230} style={mystyle} autoPlay  muted loop>
                <source   src="http://www.html5rocks.com/en/tutorials/video/basics/devstories.mp4"   type="video/mp4" />
                </video>
            </Modal>

                <section className="home-bg-color" id="home">

                  <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10 text-center text-black">
                            <img src={Garuda} style={{width:200, height:200}}/>
                            {this.state.cmsData.map(this.renderHeader)}

                            <center>
                            <Paper  style={{padding: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: 700}}>

                             <InputBase
                               style = {{marginLeft: 10,
                                  flex: 1}}
                               value={this.state.searchText}
                               onChange={this.handleSearchText}
                               onKeyDown={this.onKeyPressed}
                               placeholder="Pencarian (contoh: 'jalan' atau 'bogor')"
                               inputProps={{ 'aria-label': 'search google maps' }}
                               onMouseEnter={() => this.setState({tool: true})}
                               onMouseLeave={() => this.setState({tool: false})}
                               data-tip
                             />
                             <IconButton   aria-label="search">
                               <SearchIcon />
                             </IconButton>
                             <ReactTooltip type='dark' effect='solid' place='bottom'>
                               <span>Untuk kecepatan pencarian, disarankan memilih unsur, atribut, domain atau objek terlebih dahulu</span>
                             </ReactTooltip>
                           </Paper>
                           {/* <FormControl variant='outlined' style={{padding: '2px 4px', marginLeft: '10px'}}>
                               <Select
                               defaultValue={"big"}
                               onChange={(e) => this.setState({tipePencarian: e.target.value})}
                               MenuProps={{
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left",
                                },
                                getContentAnchorEl: null,
                                style: { maxHeight: 500 },
                              }}
                               >
                                 <MenuItem value={"big"}>Pencarian KUGI</MenuItem>
                                 <MenuItem value={"objek"}>Pencarian Objek</MenuItem>
                               </Select>
                             </FormControl> */}
                           </center>
                            {/*<span  onClick={this.onOpenModal} className="pt-4 video-play-icon watch-overview d-inline-block text-black">Lihat Alur Data KUGI &nbsp;<i className="mdi mdi-chevron-right"></i></span>
                        */}</div>
                    </div>
                  </div>
                  <img src="images/macbook.png" alt="" style={{width:"100%"}} />
            </section>

            <Features />
            <Counter  />
            {/*<Services />
            <Pricing />*/}

            <Faq />
            <Contact />
        </AUX>
        );
    }
}


const mapStatetoProps = state => {
    return {
        islight: state.ui_red.islight
    };
}

const mapDispatchtoProps = dispatch => {
    return {
        UpdateLight: () => dispatch({ type: actionTypes.ISLIGHT, value: true })

    };
}

export default withRouter(connect(mapStatetoProps,  {pushSearchText})(HomeOne));
